export const COUNTRY_RESOURCE_TYPES = {
    process: {
        label: "Process",
        addLabel: "Add New Process",
        tableColumns: [
            { key: "Title", label: "Title" },
            { key: "Process", label: "Process", truncate: 80 },
            { key: "Created_At", label: "Created At", isDate: true },
        ],
        fields: [
            { name: "title", label: "Title", type: "text", required: true },
            { name: "process", label: "Process", type: "textarea", required: true },
        ],
    },
    rebuttles: {
        label: "Rebuttles",
        addLabel: "Add New Rebuttle",
        tableColumns: [
            { key: "Title", label: "Title" },
            { key: "Rebuttles", label: "Rebuttles", truncate: 80 },
            { key: "Created_At", label: "Created At", isDate: true },
        ],
        fields: [
            { name: "title", label: "Title", type: "text", required: true },
            { name: "rebuttles", label: "Rebuttles", type: "textarea", required: true },
        ],
    },
    "brief-form": {
        label: "Brief Form",
        addLabel: "Add Brief Form",
        hasFile: true,
        tableColumns: [
            { key: "Title", label: "Title" },
            { key: "File_Name", label: "File Name" },
            { key: "Created_At", label: "Created At", isDate: true },
        ],
        fields: [
            { name: "title", label: "Title", type: "text", required: true },
            { name: "file", label: "File (PDF, Excel, Word)", type: "file", required: true },
        ],
        editFields: [
            { name: "title", label: "Title", type: "text", required: true },
            { name: "file", label: "Replace File (optional)", type: "file", required: false },
        ],
    },
    "brand-contact": {
        label: "Brand Contact Details",
        addLabel: "Add Contact Details",
        tableColumns: [
            { key: "Brand_Name", label: "Brand Name" },
            { key: "Website", label: "Website" },
            { key: "Phone", label: "Phone" },
            { key: "Details", label: "Details", truncate: 60 },
        ],
        fields: [
            { name: "brandName", label: "Brand Name", type: "text", required: true },
            { name: "website", label: "Website", type: "text", required: false },
            { name: "phone", label: "Phone", type: "text", required: false },
            { name: "details", label: "Details", type: "textarea", required: false },
        ],
    },
    "attorney-details": {
        label: "Attorney Details",
        addLabel: "Add Attorney Details",
        tableColumns: [
            { key: "Name", label: "Name" },
            { key: "Phone", label: "Phone" },
            { key: "Email", label: "Email" },
            { key: "Address", label: "Address", truncate: 50 },
            { key: "Website", label: "Website" },
        ],
        fields: [
            { name: "name", label: "Name", type: "text", required: true },
            { name: "phone", label: "Phone", type: "text", required: false },
            { name: "email", label: "Email", type: "email", required: false },
            { name: "address", label: "Address", type: "textarea", required: false },
            { name: "website", label: "Website", type: "text", required: false },
        ],
    },
    "clearance-report": {
        label: "Clearance Report",
        addLabel: "Add Clearance Report",
        hasFile: true,
        tableColumns: [
            { key: "Title", label: "Title" },
            { key: "File_Name", label: "File Name" },
            { key: "Created_At", label: "Created At", isDate: true },
        ],
        fields: [
            { name: "title", label: "Title", type: "text", required: true },
            { name: "file", label: "File (PDF, Excel, Word)", type: "file", required: true },
        ],
        editFields: [
            { name: "title", label: "Title", type: "text", required: true },
            { name: "file", label: "Replace File (optional)", type: "file", required: false },
        ],
    },
};

export const COUNTRY_RESOURCE_MENU = [
    { type: "process", label: "Process", icon: "bi-list-check" },
    { type: "rebuttles", label: "Rebuttles", icon: "bi-chat-left-text" },
    { type: "brief-form", label: "Brief Form", icon: "bi-file-earmark-text" },
    { type: "brand-contact", label: "Brand Contact Details", icon: "bi-building" },
    { type: "attorney-details", label: "Attorney Details", icon: "bi-person-badge" },
    { type: "clearance-report", label: "Clearance Report", icon: "bi-file-earmark-check" },
];

export function getResourceConfig(type) {
    return COUNTRY_RESOURCE_TYPES[type] || null;
}
